import { QurealViewer, useQurealActions } from "qureal-editor";
import React, { useEffect, useState } from "react";
import { useMeasure } from "react-use";
import styles from "./styles/QurealCanvas.module.css";
import { Button } from "antd";
import { getEditURL } from "../../_helpers/editor";
import {
    DownloadOutlined,
    ShareAltOutlined,
    SyncOutlined,
    ThunderboltOutlined,
    EyeOutlined,
    CloseOutlined,
    UploadOutlined,
} from "@ant-design/icons";
import classNames from "classnames";
import { MessageCodeView } from "../../ai_home/ChatBox";
import language from "react-syntax-highlighter/dist/esm/languages/hljs/1c";
import QurealCanvasWrapper from "./QurealCanvasWrapper";


function QurealDocumentCanvas({ slug, is_template, item, prefill, isLoading = false, data }) {
    const [ref, { x, y, width, height, top, right, bottom, left }] = useMeasure();
    const { actionRef, download, share } = useQurealActions();
    const [status, setStatus] = useState({
        download: false,
        share: false,
    });

    const header_height = 50;
    const isMobile = false
    const url = `https://show.qureal.com/${is_template ? "td" : "d"}/${slug}`

    const [section_list, setSectionList] = useState([]);


    useEffect(() => {
        const raw_sections = data?.data?.sections || [];
        const out = raw_sections.map((section, index) => {
            const sec = section;
            const section_type = "letter_body";
            // const section_type = "document_body";
            return {
                id: `index_${index}`,
                index: index,
                type: "dynamic",
                preset: section_type,
                prefill: {
                    letter_body: section
                }
            }
        })
        setSectionList(out)
    }, [data])

    // useEffect(() => {
    //     const raw_sections = data?.data || [];
    //     const out = raw_sections.map((section, index) => {
    //         const sec = section?.section || {};
    //         const section_type = TYPE_MAPPING[sec?.type] || sec?.type
    //         return {
    //             id: section?.title,
    //             index: index,
    //             type: "dynamic",
    //             preset: section_type,
    //             prefill: {
    //                 [section_type]: sec
    //             },
    //         }
    //     })
    //     setSectionList(out)
    // }, [data])


    return <QurealCanvasWrapper>
        {section_list?.length > 0 && <QurealViewer
            key={`${slug}-${width}-${height}`}
            slug="document_ZzE4y"
            preview={true}
            style={{
                width: width,
                // width: width - 400,
                height: height - header_height,
                height: "100%",
                // width: "50vh",
                // height: "50vh",
                outline: "none",
                border: "1px solid transparent"
            }}
            // organization={org}
            // person={person}
            actionRef={actionRef}
            type="creation"
            creation_type="document"
            fit={true}
            // background="white"
            background="black"
            onInit={(data) => {
                setSectionList(old_list => ([
                    ...old_list,
                    {}
                ]))
            }}
            // prefill={prefill}
            section_list={section_list}
            onStatusUpdate={(data) => {
                setStatus(data);
            }}
        // is_local={true}
        />}
    </QurealCanvasWrapper>



    return <div ref={ref} className={styles.wrapper}>

        <MessageCodeView
            data={{
                language: "json",
                code: section_list
            }}
        />
        {/* <Button onClick={() => {
            setSectionList(old_list => ([
                ...old_list,
                {}
            ]))
        }}>Render</Button> */}
        <div className={styles.header} style={{ height: header_height }}>
            <div className={styles.header_left}>
                <div className={styles.title}>Document {item.title}</div>

            </div>
            <div className={styles.header_right}>
                {!is_template && (
                    <a
                        // href={editor_url}
                        href={getEditURL(item.id)}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <Button>Edit</Button>
                    </a>
                )}
                <a
                    href={url}
                    target="_blank"
                    rel="noreferrer"
                >
                    {isMobile ? (
                        <Button
                            icon={<EyeOutlined />}
                        ></Button>
                    ) : (
                        <Button icon={<EyeOutlined />}>
                            {/* Full page view */}
                        </Button>
                    )}
                </a>
                <Button
                    onClick={download}
                    // type="primary"
                    loading={status?.download}
                    icon={<DownloadOutlined />}
                >
                    {/* Download */}
                </Button>
                <Button
                    onClick={share}
                    // type="primary"
                    loading={status?.share}
                    icon={<ShareAltOutlined />}
                >
                    {/* Share */}
                </Button>
            </div>
        </div>
        <div
            // className={styles.canvas}
            className={classNames([styles.canvas, styles.editor_back_pattern])}
        >
            {section_list?.length > 0 && <QurealViewer
                key={`${slug}-${width}-${height}`}
                slug="document_ZzE4y"
                preview={true}
                style={{
                    width: width,
                    // width: width - 400,
                    height: height - header_height,
                    height: "100%",
                    // width: "50vh",
                    // height: "50vh",
                    outline: "none",
                    border: "1px solid transparent"
                }}
                // organization={org}
                // person={person}
                actionRef={actionRef}
                type="creation"
                creation_type="document"
                fit={true}
                // background="white"
                background="black"
                onInit={(data) => {
                    setSectionList(old_list => ([
                        ...old_list,
                        {}
                    ]))
                }}
                // prefill={prefill}
                section_list={section_list}
                onStatusUpdate={(data) => {
                    setStatus(data);
                }}
            // is_local={true}
            />}

            {/* {loading && (
            <div className={styles.preview_loading_wrapper}>
                <GenerationLoading />
            </div>
        )} */}
        </div>

        {isLoading && <div className={styles.loading_wrapper}>
            Generating....
        </div>}

    </div>
}

export default QurealDocumentCanvas;



const TYPE_MAPPING = {
    content: "document_body"
}